
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stylebook",
      function () {
        return require("private-next-pages/stylebook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stylebook"])
      });
    }
  